"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.isDefectItem = exports.isEditItem = exports.isViewTitle = exports.isViewItem = exports.YesNo = exports.AutoManual = exports.PreventDetective = exports.Period = void 0;
var lodash_1 = __importDefault(require("lodash"));
var Config_1 = require("../../utils/Config");
var TimeUtils_1 = require("../../utils/TimeUtils");
var PRC_1 = require("../PRC");
var Staff_1 = require("../Staff");
var Translation_1 = require("../Translation");
var AbstractRisk_1 = require("../risk/AbstractRisk");
var DesignReportColumn_1 = require("./DesignReportColumn");
// period : 건별,일별수시,일별,주별,월별,분기별,반기별,연별,상시
var Period;
(function (Period) {
    Period["byCase"] = "\uAC74\uBCC4";
    Period["dailyAnyTime"] = "\uC77C\uBCC4\uC218\uC2DC";
    Period["daily"] = "\uC77C\uBCC4";
    Period["weekly"] = "\uC8FC\uBCC4";
    Period["monthly"] = "\uC6D4\uBCC4";
    Period["quarterly"] = "\uBD84\uAE30\uBCC4";
    Period["halfBiAnnual"] = "\uBC18\uAE30\uBCC4";
    Period["annual"] = "\uC5F0\uBCC4";
    Period["always"] = "\uC0C1\uC2DC";
})(Period = exports.Period || (exports.Period = {}));
var PreventDetective;
(function (PreventDetective) {
    PreventDetective["prevent"] = "\uC608\uBC29";
    PreventDetective["detective"] = "\uC801\uBC1C";
})(PreventDetective = exports.PreventDetective || (exports.PreventDetective = {}));
var AutoManual;
(function (AutoManual) {
    AutoManual["auto"] = "\uC790\uB3D9\uD1B5\uC81C";
    AutoManual["manual"] = "\uC218\uB3D9\uD1B5\uC81C";
    AutoManual["ITAC"] = "ITAC";
})(AutoManual = exports.AutoManual || (exports.AutoManual = {}));
var YesNo;
(function (YesNo) {
    YesNo["yes"] = "Yes";
    YesNo["no"] = "No";
})(YesNo = exports.YesNo || (exports.YesNo = {}));
function isTitleType(controlType) {
    return 'title' in controlType;
}
function isRadioType(controlType) {
    return 'key' in controlType && 'radio' in controlType;
}
function isCheckType(controlType) {
    return 'key' in controlType && 'checks' in controlType;
}
function isTextType(controlType) {
    return 'key' in controlType && !isRadioType(controlType) && !isCheckType(controlType);
}
function isViewItem(v) {
    return 'name' in v;
}
exports.isViewItem = isViewItem;
function isViewTitle(v) {
    var keys = lodash_1.default.keys(v);
    return keys.length === 1 && keys[0] === 'value';
}
exports.isViewTitle = isViewTitle;
function isEditItem(v) {
    return 'name' in v;
}
exports.isEditItem = isEditItem;
function isDefectItem(v) {
    return 'type' in v && (v.type === 'risk' || v.type === 'control');
}
exports.isDefectItem = isDefectItem;
function setCheckTypes(control, prefix, keys, selected) {
    lodash_1.default.forEach(keys, function (key) {
        lodash_1.default.set(control, "".concat(prefix, "_").concat(key), lodash_1.default.includes(selected, key) ? YesNo.yes : YesNo.no);
    });
}
function prepareCheckTypes(control, key, subKeys) {
    var checked = [];
    lodash_1.default.forEach(subKeys, function (subKey) {
        var value = lodash_1.default.get(control, "".concat(key, "_").concat(subKey));
        if (value === YesNo.yes) {
            checked.push(subKey);
        }
    });
    return checked;
}
var AbstractControl = /** @class */ (function () {
    function AbstractControl() {
        // PRC properties
        this.type = PRC_1.PRCType.control;
        this.id = '';
        this.name = '';
        this.cycleName = '';
        this.categoryName = '';
        this.subCategoryName = '';
        this.cycleNumber = '';
        this.categoryNumber = '';
        this.subCategoryNumber = '';
        // Common control properties
        this.owner = '';
        this.incharge = '';
        this.department = '';
        this.processCode = '';
        this.riskNumber = '';
        this.riskName = '';
        this.preventDetective = PreventDetective.prevent;
        this.keyControl = YesNo.no;
        this.narrative = '';
        this.period = Period.byCase;
        this.controlRiskLevel = AbstractRisk_1.RiskLevel.low;
        this.residualRiskLevel = AbstractRisk_1.RiskLevel.low;
        // TODO(sangmuk): Consider to move common propertes from Dayou and Legacy.
        // not from Excel
        // TODO(sangmuk): Array를 하나의 값으로 설정
        this.staffIds = [];
        this.departmentIds = [];
        this.cycleIds = [];
        this.processIds = [];
        this.riskIds = [];
    }
    AbstractControl.getKeysForExporting = function (controlTypes) {
        var keys = controlTypes.reduce(function (result, current) {
            if (isTitleType(current)) {
                return result;
            }
            if (isCheckType(current)) {
                current.checks.forEach(function (check) {
                    var key = "".concat(current.prefix, "_").concat(check);
                    result[key] = (0, Translation_1.getKoName)('control', key);
                });
                return result;
            }
            result[current.key] = (0, Translation_1.getKoName)('control', current.key);
            return result;
        }, {});
        return __assign({ id: (0, Translation_1.getKoName)('control', 'id'), name: (0, Translation_1.getKoName)('control', 'name'), cycleName: (0, Translation_1.getKoName)('common', 'cycleName'), categoryName: (0, Translation_1.getKoName)('common', 'categoryName'), subCategoryName: (0, Translation_1.getKoName)('common', 'subCategoryName'), cycleNumber: (0, Translation_1.getKoName)('common', 'cycleNumber'), categoryNumber: (0, Translation_1.getKoName)('common', 'categoryNumber'), subCategoryNumber: (0, Translation_1.getKoName)('common', 'subCategoryNumber'), owner: (0, Translation_1.getKoName)('control', 'owner'), incharge: (0, Translation_1.getKoName)('control', 'incharge'), department: (0, Translation_1.getKoName)('control', 'department'), processCode: (0, Translation_1.getKoName)('control', 'processCode'), riskNumber: (0, Translation_1.getKoName)('control', 'riskNumber'), riskName: (0, Translation_1.getKoName)('control', 'riskName'), keyControl: (0, Translation_1.getKoName)('control', 'keyControl'), narrative: (0, Translation_1.getKoName)('control', 'narrative'), period: (0, Translation_1.getKoName)('control', 'period'), controlRiskLevel: (0, Translation_1.getKoName)('control', 'controlRiskLevel'), residualRiskLevel: (0, Translation_1.getKoName)('control', 'residualRiskLevel') }, keys);
    };
    AbstractControl.from = function (data) {
        throw new Error('Not implemented');
    };
    AbstractControl.prepareEditingControlsInner = function (controlTypes, control) {
        return controlTypes.reduce(function (result, current) {
            if (isCheckType(current)) {
                result[current.key] = prepareCheckTypes(control, current.prefix, current.checks);
            }
            return result;
        }, {});
    };
    AbstractControl.prepareEditingControls = function (control) {
        throw new Error('Not implemented');
    };
    AbstractControl.getControlEditItems = function (controlTypes) {
        return lodash_1.default.compact(controlTypes.map(function (controlType) {
            if (isTitleType(controlType)) {
                return { value: controlType.title };
            }
            if (controlType.key === 'id')
                return undefined;
            if (isTextType(controlType)) {
                return {
                    name: controlType.key,
                    required: controlType.required,
                    isStaff: controlType.isStaff,
                    isDepartment: controlType.isDepartment
                };
            }
            else if (isRadioType(controlType)) {
                return {
                    name: controlType.key,
                    radioTypes: controlType.radio
                };
            }
            else if (isCheckType(controlType)) {
                return {
                    name: controlType.key,
                    prefix: controlType.prefix,
                    checkTypes: controlType.checks
                };
            }
            throw new Error("Invalid control type ".concat(controlType));
        }));
    };
    AbstractControl.convertFormToControlInner = function (controlTypes, formValues, control) {
        // general part
        control.type = PRC_1.PRCType.control;
        control.cycleName = lodash_1.default.get(formValues, 'cycleName');
        control.categoryName = lodash_1.default.get(formValues, 'categoryName');
        control.subCategoryName = lodash_1.default.get(formValues, 'subCategoryName');
        control.cycleNumber = lodash_1.default.get(formValues, 'cycleNumber');
        control.categoryNumber = lodash_1.default.get(formValues, 'categoryNumber');
        control.subCategoryNumber = lodash_1.default.get(formValues, 'subCategoryNumber');
        control.riskNumber = lodash_1.default.get(formValues, 'riskId');
        control.riskIds = [control.riskNumber];
        control.processCode = lodash_1.default.get(formValues, 'processId');
        control.processIds = [control.processCode];
        control.cycleIds = lodash_1.default.get(formValues, 'cycleIds', []);
        control.staffIds = [lodash_1.default.get(formValues, 'owner')];
        controlTypes.forEach(function (controlType) {
            if (isTextType(controlType) || isRadioType(controlType)) {
                // TODO(sangmuk): Check required value.
                lodash_1.default.set(control, controlType.key, lodash_1.default.get(formValues, controlType.key, ''));
            }
            else if (isCheckType(controlType)) {
                setCheckTypes(control, controlType.prefix, controlType.checks, lodash_1.default.get(formValues, controlType.key, []));
            }
        });
        return control;
    };
    AbstractControl.prototype.convertFromToControl = function (formValues, selectedStaff) {
        throw new Error('Not implemented');
    };
    AbstractControl.prototype.updateForOperationTemplate = function (newControl) {
        this.name = newControl.name; // OE
        this.narrative = newControl.narrative; // OE, DE
        this.keyControl = newControl.keyControl; // OE, DE
        this.period = newControl.period; // OE, DE
        this.controlRiskLevel = newControl.controlRiskLevel; // DE
    };
    AbstractControl.prototype.getControlViewItemsInner = function (controlTypes, staffs) {
        var _this = this;
        return controlTypes.map(function (controlType) {
            if (isTitleType(controlType)) {
                return { value: controlType.title };
            }
            else if (isTextType(controlType) && !controlType.isStaff) {
                return _this.getSimpleViewItem(controlType.key);
            }
            else if (isTextType(controlType) && controlType.isStaff) {
                return __assign(__assign({}, _this.getSimpleViewItem(controlType.key)), { staff: lodash_1.default.find(staffs, { id: lodash_1.default.get(_this, controlType.key) }) });
            }
            else if (isRadioType(controlType)) {
                return _this.getSimpleViewItem(controlType.key, controlType.radio);
            }
            else if (isCheckType(controlType)) {
                return _this.getCheckViewItem(controlType.key, controlType.checks.reduce(function (result, check) {
                    var key = "".concat(controlType.prefix, "_").concat(check);
                    result[key] = lodash_1.default.get(_this, key, YesNo.no);
                    return result;
                }, {}));
            }
            throw new Error("Invalid control type ".concat(controlType));
        });
    };
    AbstractControl.prototype.getSimpleViewItem = function (id, radioTypes) {
        if (!(id in this)) {
            throw new Error("properties ".concat(id, " not found in Control ").concat(this));
        }
        return {
            name: (0, Translation_1.getKoName)('control', id),
            value: lodash_1.default.get(this, id, ''),
            radioTypes: radioTypes
        };
    };
    AbstractControl.prototype.getCheckViewItem = function (id, values) {
        return {
            checkTypes: true,
            name: (0, Translation_1.getKoName)('control', id),
            value: values
        };
    };
    AbstractControl.getDesignDefectInner = function (controlTypes) {
        var defects = lodash_1.default.flatten(controlTypes.map(function (controlType) {
            if (isTitleType(controlType)) {
                return { value: controlType.title };
            }
            else if (isTextType(controlType)) {
                return { type: 'control', key: controlType.key, isStaff: controlType.isStaff };
            }
            else if (isRadioType(controlType)) {
                return { type: 'control', key: controlType.key, radio: controlType.radio };
            }
            else if (isCheckType(controlType)) {
                return __spreadArray([
                    {
                        value: (0, Translation_1.getKoName)('control', controlType.key)
                    }
                ], controlType.checks.map(function (check) { return ({
                    type: 'control',
                    key: "".concat(controlType.prefix, "_").concat(check),
                    isBoolean: true
                }); }), true);
            }
            throw new Error("Invalid control type ".concat(controlType));
        }));
        defects.splice(0, 0, { value: '통제 기본 정보' });
        var tocIdx = defects.findIndex(function (defect) { return 'value' in defect && defect.value === '통제 운영 속성'; });
        if (tocIdx < 0) {
            throw new Error("Can't find TOC information.");
        }
        var infoData = defects.slice(0, tocIdx);
        var methodData = defects.slice(tocIdx);
        return { infoData: infoData, methodData: methodData };
    };
    AbstractControl.getDesignDefect = function () {
        throw new Error('Not implemented');
    };
    AbstractControl.getDesignDefectSummaryInner = function (controlTypes) {
        var title = '통제 기본 정보';
        return controlTypes.reduce(function (result, controlType) {
            if (isTitleType(controlType)) {
                title = controlType.title;
                return result;
            }
            if (!(title in result)) {
                if (title === '통제 운영 속성') {
                    result['관련 위험'] = [];
                }
                result[title] = [];
            }
            if (isTextType(controlType) || isRadioType(controlType)) {
                result[title].push({ key: 'control', subKey: controlType.key });
            }
            else if (isCheckType(controlType)) {
                result[(0, Translation_1.getKoName)('control', controlType.key)] = controlType.checks.map(function (check) { return ({
                    key: 'control',
                    subKey: "".concat(controlType.prefix, "_").concat(check)
                }); });
            }
            return result;
        }, {});
    };
    AbstractControl.getDesignDefectSummary = function () {
        throw new Error('Not implemeted');
    };
    AbstractControl.getDesignColumnsInner = function (staffs, isEditing, hasGoal, considerations, controlTypes, tocColumns) {
        var controlDetails = [
            [
                { value: (0, Translation_1.getKoName)('control', 'OwnerAssessment'), span: 3, style: DesignReportColumn_1.blueStyle },
                isEditing
                    ? {
                        key: 'ownerAssessment',
                        editable: true,
                        type: 'TextArea',
                        span: 21,
                        placeholder: 'RCM상 통제 담당자의 변경이 있는 경우:\n' +
                            '  (1) 신규 통제 담당자에 대한 평가 필요.\n' +
                            '  (2) 하기 RCM 수정 항목에서 통제 담당자를 신규 통제 담당자로 변경\n' +
                            'RCM상 통제 담당자의 변경이 없는 경우: RCM상 통제 담당자에 대한 평가'
                    }
                    : { key: 'content.data.ownerAssessment', span: 21, style: { whiteSpace: 'pre-line' } }
            ]
        ];
        var considerationColumns = (0, lodash_1.default)(considerations)
            .map(function (_a, i) {
            var title = _a.title, content = _a.content;
            var index = i + 1;
            return [
                [
                    { value: "Consideration ".concat(index, ": ").concat(title), span: 18, style: DesignReportColumn_1.blueStyle },
                    { value: '평가 결론', span: 3, style: DesignReportColumn_1.greyStyle },
                    { key: "content.data.considerations[".concat(i, "].result"), span: 3 }
                ],
                [
                    { value: content, span: 8, style: { backgroundColor: '#E2EFDA' } },
                    {
                        key: "content.data.considerations[".concat(i, "].content"),
                        span: 16,
                        style: { whiteSpace: 'pre-line' }
                    }
                ]
            ];
        })
            .flatten()
            .value();
        var riskControlColumn = [
            [
                { value: (0, Translation_1.getKoName)('risk', 'id'), span: 3, style: DesignReportColumn_1.greyStyle },
                { key: 'content.risk.id', span: 3 },
                { value: (0, Translation_1.getKoName)('risk', 'name'), span: 3, style: DesignReportColumn_1.greyStyle },
                { key: 'content.risk.name', span: 15 }
            ],
            [
                { value: (0, Translation_1.getKoName)('control', 'id'), span: 3, style: DesignReportColumn_1.greyStyle },
                { key: 'controlId', span: 3 },
                { value: (0, Translation_1.getKoName)('control', 'name'), span: 3, style: DesignReportColumn_1.greyStyle },
                { key: 'content.control.name', span: 15 }
            ]
        ];
        if (hasGoal) {
            riskControlColumn.push([
                { value: (0, Translation_1.getKoName)('control', 'goal'), span: 3, style: DesignReportColumn_1.greyStyle },
                { key: 'content.control.goal', span: 15 }
            ]);
        }
        riskControlColumn.push.apply(riskControlColumn, [
            [
                { value: (0, Translation_1.getKoName)('control', 'narrative'), span: 3, style: DesignReportColumn_1.greyStyle },
                { key: 'content.control.narrative', span: 15 }
            ],
            [
                { value: '통제유형', span: 3, style: DesignReportColumn_1.greyStyle },
                {
                    key: 'controlTypesChildren',
                    span: 21,
                    children: controlTypes
                }
            ]
        ]);
        return {
            processColumns: [
                [
                    { value: (0, Translation_1.getKoName)('common', 'cycleName'), span: 3, style: DesignReportColumn_1.greyStyle },
                    { key: 'content.control.cycleName', span: 9 },
                    { value: (0, Translation_1.getKoName)('control', 'createDate'), span: 3, style: DesignReportColumn_1.greyStyle },
                    {
                        key: 'content.data.createDate',
                        span: 9,
                        valueFormatter: function (value) { return (0, TimeUtils_1.parseDateStr)('YYYY-MM-DD', value); }
                    }
                ],
                [
                    { value: (0, Translation_1.getKoName)('common', 'categoryName', (0, Config_1.getProjectId)()), span: 3, style: DesignReportColumn_1.greyStyle },
                    { key: 'content.control.categoryName', span: 9 },
                    { value: (0, Translation_1.getKoName)('control', 'controlIncharge'), span: 3, style: DesignReportColumn_1.greyStyle },
                    {
                        key: 'state.performer',
                        span: 9,
                        valueFormatter: function (value) { return (0, Staff_1.getStaffNameAndEmailById)(staffs, value); }
                    }
                ],
                [
                    { value: (0, Translation_1.getKoName)('common', 'processCode'), span: 3, style: DesignReportColumn_1.greyStyle },
                    { key: 'content.processCode', span: 9 },
                    { value: (0, Translation_1.getKoName)('control', 'inchargeInRCM'), span: 3, style: DesignReportColumn_1.greyStyle },
                    {
                        key: 'content.control.incharge',
                        span: 9,
                        valueFormatter: function (value) { return (0, Staff_1.getStaffNameAndEmailById)(staffs, value); }
                    }
                ],
                [
                    { value: (0, Translation_1.getKoName)('control', 'department'), span: 3, style: DesignReportColumn_1.greyStyle },
                    { key: 'state.department', span: 9 },
                    { value: (0, Translation_1.getKoName)('control', 'ownerInRCM'), span: 3, style: DesignReportColumn_1.greyStyle },
                    {
                        key: 'content.control.owner',
                        span: 9,
                        valueFormatter: function (value) { return (0, Staff_1.getStaffNameAndEmailById)(staffs, value); }
                    }
                ]
            ],
            riskControlColumn: riskControlColumn,
            controlDetailColumns: controlDetails,
            considerationColumns: __spreadArray([
                [
                    {
                        value: '통제활동의 정확도(precision) 수준에 대한 이해',
                        span: 24,
                        style: DesignReportColumn_1.greyTitleStyle
                    }
                ]
            ], considerationColumns, true),
            TOCColumns: tocColumns
        };
    };
    AbstractControl.getDesignColumns = function (staffs, isEditing) {
        throw new Error('Not implemented');
    };
    AbstractControl.getEditableDesignColumnsInner = function (considerations, tocColumns) {
        var considerationColumns = lodash_1.default.flatten(lodash_1.default.map(considerations, function (_a, i) {
            var title = _a.title, content = _a.content;
            var index = i + 1;
            return [
                [
                    { value: "Consideration ".concat(index, ": ").concat(title), span: 18, style: DesignReportColumn_1.blueStyle },
                    { value: '평가 결론', span: 3, style: DesignReportColumn_1.greyStyle },
                    {
                        key: "considerationResult_".concat(index),
                        span: 3,
                        editable: true,
                        type: 'Select',
                        options: ['Effective', 'Ineffective']
                    }
                ],
                [
                    {
                        value: content,
                        span: 8,
                        style: { backgroundColor: '#2EFDA', whiteSpace: 'pre-line' }
                    },
                    {
                        key: "considerationContent_".concat(index),
                        span: 16,
                        type: 'TextArea',
                        editable: true
                    }
                ]
            ];
        }));
        return {
            considerationColumns: __spreadArray([
                [
                    {
                        value: '통제활동의 정확도(precision) 수준에 대한 이해',
                        span: 24,
                        style: DesignReportColumn_1.greyTitleStyle
                    }
                ]
            ], considerationColumns, true),
            TOCColumns: tocColumns
        };
    };
    AbstractControl.getEditableDesignColumns = function () {
        throw new Error('Not implemented');
    };
    return AbstractControl;
}());
exports.default = AbstractControl;
//# sourceMappingURL=AbstractControl.js.map